import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { EstimatesV2Service } from '../../../core/services/estimateV2.service';
import { QuoteRequestRecipient } from '../../../data/models';
import { BxDocumentsComponent } from '../bx-documents/bx-documents.component';

@Component({
    selector: 'app-rfq-response-attachments',
    templateUrl: './rfq-response-attachments.component.html',
    standalone: false,
})
export class RfqResponseAttachmentsComponent implements OnChanges {
    // @ts-ignore TS2564
    @ViewChild('attachments') attachments: BxDocumentsComponent;
    // @ts-ignore TS2564
    @Input() recipient: QuoteRequestRecipient;
    @Output() attachmentCountEvent: EventEmitter<number> = new EventEmitter<number>();
    // @ts-ignore TS2322
    current: QuoteRequestRecipient = null;

    constructor(public estimateV2Service: EstimatesV2Service) {}

    ngOnChanges(changes: SimpleChanges): void {
        const recipientChanged = changes['recipient'];
        if (recipientChanged && recipientChanged.currentValue !== recipientChanged.previousValue) {
            this.current = recipientChanged.currentValue;
            this.attachments.loadReference(`${this.current.iD_QuoteRequest}/${this.current.iD_QuoteRequestRecipient}`);
        }
    }

    uploadOrDelete() {
        if (this.current?.iD_QuoteRequestRecipient !== null) {
            this.estimateV2Service.syncRFQFilesToEstimateDocuments(this.current.iD_QuoteRequestRecipient).subscribe();
        }
    }

    fileCountChanged(count: number) {
        this.attachmentCountEvent.emit(count);
    }
}
